import React from 'react'
import {Link} from 'gatsby'
import PresentationPreview from './presentation-preview'

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import '../styles/presentation-preview-list.css'

class PresentationPreviewList extends React.Component {
  constructor(props) {
    super(props);
      this.state = {
        slideIndex: 0
      };
  }

  slidePrevious = (value) => {
    this.slider.slickPrev();
  }

  slideNext = (value) => {
    this.slider.slickNext();
  }

  render() {

    //console.log('slides');
    var settings = {
    dots: false,
    arrows: false,
    className: "center",
    centerMode: true,
    infinite: true,
    slidesToShow: 3,
    speed: 700,
    swipeToSlide: true,
    responsive: [
          {
            breakpoint: 700,
              settings: {
              slidesToShow: 1,
            }
          },
        ]
  };

    return (

    <>
      <div className="wrapper">
        {this.props.title && this.props.browseMoreHref && <h3 className="preview"><Link to={this.props.browseMoreHref}>{this.props.title}</Link></h3>}
      </div>
    <div className="presentation-preview-list">
      <div id="presentation-preview-list">

          <Slider ref={slider => (this.slider = slider)} {...settings}>
          {this.props.nodes &&
            this.props.nodes.map(node => (
              <PresentationPreview {...node} />
          ))}
          </Slider>
          <div style={{ textAlign: "center" }}>
            <button className="button prev" onClick={this.slidePrevious}>
            </button>
            <button className="button next" onClick={this.slideNext}>
            </button>
          </div>
      </div>
    </div>
    </>
      
    )
  }
}

export default PresentationPreviewList